import { render, staticRenderFns } from "./CourseNoticeManagement.vue?vue&type=template&id=78322033&scoped=true"
import script from "./CourseNoticeManagement.vue?vue&type=script&lang=js"
export * from "./CourseNoticeManagement.vue?vue&type=script&lang=js"
import style0 from "./CourseNoticeManagement.vue?vue&type=style&index=0&id=78322033&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78322033",
  null
  
)

export default component.exports